import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import DiscountBadge from './DiscountBadge';
import styles from './ItemDiscountTag.module.css';

interface ItemDiscountTagProps {
    additionalDiscountPercentage?: number;
    dealerDiscountPercentage: number;
    onSale: boolean;
    isSpecial?: boolean;
}

const ItemDiscountTagContent = memo(
    ({
        dealerDiscountPercentage,
        additionalDiscountPercentage,
        onSale,
        isSpecial = false,
    }: ItemDiscountTagProps) => {
        const badgeType = onSale ? 'sale' : 'personal';

        const additionalDiscountBadge = !!(
            additionalDiscountPercentage && additionalDiscountPercentage > 0
        ) && (
            <DiscountBadge
                type="sale"
                percentage={additionalDiscountPercentage}
            />
        );

        const discountBadge = isSpecial ? (
            <DiscountBadge
                type="sale"
                percentage={0}
                text={<FormattedMessage id="special" />}
            />
        ) : (
            additionalDiscountBadge
        );

        return (
            <>
                {dealerDiscountPercentage > 0 && !isSpecial && (
                    <DiscountBadge
                        type={badgeType}
                        percentage={dealerDiscountPercentage}
                    />
                )}
                {discountBadge}
            </>
        );
    }
);

const ItemDiscountTag = ({ ...props }: ItemDiscountTagProps) => {
    return (
        <div className={styles.layout}>
            <ItemDiscountTagContent {...props} />
        </div>
    );
};

export default memo(ItemDiscountTag);
